import axios from "axios";
export default {
  API_ADDRESS: "https://pr1rj3dmma.execute-api.eu-west-1.amazonaws.com/",
  ENDPOINTS: {
    GET_GATEWAYS: "wizard/fetch-wizards",
    UPDATE_WIZARD: "wizard/update-wizard",
    CREATE_WIZARD: "wizard/manage-wizards",
    DELETE_WIZARD: "wizard/delete-wizard"
  },
  getGateways() { 
    var idToken = localStorage.getItem("idToken");
    return axios.get(this.API_ADDRESS + this.ENDPOINTS.GET_GATEWAYS, {
      headers: {
        Authorization: "Bearer " + idToken
      }
    });
  },
  createGateway(email, gatewayAddress) {
    const payload = {
      email: email,
      gateway_id: gatewayAddress
    };
    var idToken = localStorage.getItem("idToken");
    return axios.post(this.API_ADDRESS + this.ENDPOINTS.CREATE_WIZARD, payload, {
      headers: {
        Authorization: "Bearer " + idToken
      }
    });
  },
  deleteGateway(email, gatewayAddress) {
    const payload = {
      email: email,
      gateway_id: gatewayAddress
    };

    var idToken = localStorage.getItem("idToken");
    return axios({
      url:this.API_ADDRESS + this.ENDPOINTS.DELETE_WIZARD,
      method:'delete',
      data : payload,
      headers:{Authorization: "Bearer " + idToken}
    });
  },
  updateGateway(email, gatewayAddress) {
    const payload = {
      email: email,
      gateway_id: gatewayAddress
    };
    var idToken = localStorage.getItem("idToken");
    return axios.put(this.API_ADDRESS + this.ENDPOINTS.UPDATE_WIZARD, payload,{
      headers: {
        Authorization: "Bearer " + idToken
      }
    });
  }
}